import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from './localeConstants';
export const detectLocale = () => {
  const browserLang = navigator.language;
  if (SUPPORTED_LOCALES.includes(browserLang)) {
    return browserLang;
  }
  const browserPrimaryLang = browserLang?.split('-')[0];
  // Order in SUPPORTED_LOCALES determines which locale wins when multiple share a primary tag.
  const matched = SUPPORTED_LOCALES.find(locale => locale.split('-')[0] === browserPrimaryLang);
  return matched ?? DEFAULT_LOCALE;
};